export default __webpack_public_path__ + "38c4ecc6d46a53cb7550da816d9342f0.png";